import React from "react";
import ReactDOM from "react-dom";

// Frameworks
import $ from "jquery";

// Utilities
import detect from "./utilities/detect";

// Components
import MegaMenuNavigation from "./components/megaMenuNavigation";
import MobileMenu from "./components/mobileMenu";
import headerSearch from "./components/headerSearch";
import ScrollTop from "./components/scrollTop";
import "./components/videoElement";
import Accordion from "./components/accordion";
import Anchor from "./components/anchors";
import AutoSuggestElasticSearchBox from "./components/search/AutoSuggestElasticSearchBox";
import CheckboxFilters from "./components/checkbox-filters";
import "./components/socialToggle";
import SiteAnnouncement from "./components/alert";
import sortSelect from "./components/sortSelect";
import DocumentLibrary from "./components/document-library";
import responsiveTables from "./components/responsiveTables";
import "./components/partial-form";
import "./components/assessor-filter";
import "./components/assessor-search";
import "./components/subsitePrimaryColour";
import "./components/listingsBackButton";
import decisionTree from "./decision-tree";

// Bind jquery to the window if it isn't bound already
window.jQuery = window.jQuery || $;

/**
 * Once our DOM has loaded
 * Initialise our scripts
 */
document.addEventListener("DOMContentLoaded", () => {
  // Detect our browser so we can do nasty windows hacks
  detect();

  MobileMenu();
  Accordion();
  DocumentLibrary();

  /* eslint-disable */
  const consultationFilters = new CheckboxFilters(
    ".checkbox-toggle",
    ".listing-form",
    "[data-inject='search-results']",
    "checkbox-toggle--active"
  );
  /* eslint-enable */

  new MegaMenuNavigation(); // eslint-disable-line

  const jumpLinkSelector = ".content-area h2:not([data-ignore])";
  const jumpLinksCount = document.querySelectorAll(jumpLinkSelector).length;

  if (jumpLinksCount > 2) {
    new Anchor(jumpLinkSelector); // eslint-disable-line
  } else if (document.querySelector(".jumplink-content")) {
    document.querySelector(".jumplink-content").style.display = "none";
  }

  responsiveTables();
  sortSelect();
  SiteAnnouncement();
  ScrollTop();
  decisionTree();

  const headerSearchEl = document.getElementById("header-search");
  if (headerSearchEl) {
    ReactDOM.render(<AutoSuggestElasticSearchBox />, headerSearchEl);
  }
  setTimeout(() => {
    headerSearch();
  }, 1000);
});
